import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import { BsFillCheckCircleFill } from 'react-icons/bs'

export default function Challenges(props) {
    const data = props.data

    return (
        <>
            <section className='challenges_section py-5'>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className='head text-center py-5'>
                                <h2>The Challenges</h2>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className='challenges_content py-5'>
                                <div className='list_content'>
                                    <ul>
                                        {data && data?.challenges?.map((item) =>
                                            <li>
                                                <div className='list_item' style={{ display: "flex", gap: "20px" }}>
                                                    <div className='list_icon'><BsFillCheckCircleFill /></div>
                                                    <div className='list_description'>
                                                        {item.content}
                                                    </div>
                                                </div><br/>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                            <div className='challenges_img_wrapper'>
                                {/* {
                                    data && data.challenges_image != null ? 
                                    <Image src={data.challenges_image.image} className="img_side" alt='overview' fluid />
                                    :
                                    <Image src="https://dummyimage.com/600x400/000/fff" className="img_side" alt='overview' fluid />
                                } */}
                                <Image src="https://res.cloudinary.com/infograinsdevelop/image/upload/v1/media/challenges/Asset_11_cj7t8u" className="img_side" alt='overview' fluid />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}
